"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVG = void 0;
const canvas_1 = require("canvas");
const get_svgo_instance_1 = __importDefault(require("svgo-browser/lib/get-svgo-instance"));
const Utilities_1 = require("../Utilities");
const ClientSVGSetting_1 = require("./ClientSVGSetting");
const SVGOOptions_1 = __importDefault(require("./SVGOOptions"));
class SVG {
    static toBase64(svg) {
        return `data:image/svg+xml;base64,${Utilities_1.stroToBtoa(svg)}`;
    }
    static isValid(svg) {
        return SVG.parseFromString(svg) !== null;
    }
    static isHEX(color) {
        return color ? color.match(SVG.HEX_REGEXP) !== null : false;
    }
    static parseFromString(svg) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(svg, 'image/svg+xml');
        if (doc && doc.children.length > 0 && doc.children[0].nodeName === 'svg') {
            return doc.children[0];
        }
        return null;
    }
    static toImage(svg, width, height) {
        return new Promise(resolve => {
            const image = typeof canvas_1.Image !== 'undefined' ? new canvas_1.Image() : new Image();
            width && (image.width = width);
            height && (image.height = height);
            image.onload = () => {
                resolve(image);
            };
            image.src = SVG.toBase64(svg);
        });
    }
    static async toBase64Image(svg, width, height) {
        const canvas = await SVG.toBase64ToCanvas(svg, width, height);
        if (canvas_1.Canvas !== undefined) {
            return canvas.toBuffer('image/png', {
                compressionLevel: 0,
                resolution: 300,
                filters: canvas.PNG_FILTER_NONE,
            });
        }
        return new Promise(resolve => {
            ;
            canvas.toBlob(blob => {
                resolve(blob);
            }, 'image/jpeg', 1);
        });
    }
    static async toBase64ToCanvas(svg, width, height) {
        const image = await this.toImage(svg, width, height);
        const canvas = canvas_1.createCanvas(width, height);
        const context = canvas.getContext('2d', {
            pixelFormat: canvas_1.Canvas !== undefined ? 'RGBA32' : undefined,
        });
        context.antialias = 'subpixel';
        context.quality = 'best';
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';
        context.clearRect(0, 0, width, height);
        let imageWidth = image.width;
        let imageHeight = image.height;
        const ratio = imageWidth / imageHeight;
        if (imageWidth > imageHeight) {
            imageWidth = width;
            imageHeight = imageWidth / ratio;
        }
        else {
            imageHeight = height;
            imageWidth = imageHeight * ratio;
        }
        const cx = (width - imageWidth) * 0.5;
        const cy = (height - imageHeight) * 0.5;
        context.drawImage(image, cx, cy, imageWidth, imageHeight);
        return canvas;
    }
    static getInstance() {
        if (typeof SVG.instance === 'undefined') {
            SVG.instance = get_svgo_instance_1.default(SVGOOptions_1.default);
        }
        return SVG.instance;
    }
    static optimize(input) {
        return SVG.getInstance().optimize(input);
    }
    static getColors(optimized_input) {
        const match = optimized_input.match(SVG.FILL_STROKE_REGEXP);
        if (match) {
            const colors = match
                .map(color => {
                const hex = color.match(SVG.HEX_REGEXP);
                return hex ? hex[0] : null;
            })
                .filter(e => typeof e === 'string');
            return colors.filter((v, i) => colors.indexOf(v) === i);
        }
        return [];
    }
    static removeSVGClientTrack(input) {
        return input.replace(ClientSVGSetting_1.ClientSVGSetting.trackPathRegexp, '');
    }
}
exports.SVG = SVG;
SVG.HEX_REGEXP_STRING = '#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})';
SVG.FILL_STROKE_REGEXP = new RegExp(`(fill|stroke)(="|:)${SVG.HEX_REGEXP_STRING}`, 'gim');
SVG.HEX_REGEXP = new RegExp(SVG.HEX_REGEXP_STRING, 'gi');
